export default __webpack_public_path__ + "static/media/it-36.6f67781f.svg";